import apiConfig from '@/services/apiConfig';
import apiClient from '@/services/apiClient';
import ApiService from "@/common/api.service";
import {
  NOMES_PRODUTOS_API,
} from "@/common/nome.produtos.api";
import * as mutations from '@/plugins/mutations.nomes';
import store from '@/plugins/store';

const idConfigAmbiente = process.env.VUE_APP_ID_CONFIG_AMBIENTE || null;

const registrarUrlAPIs = function (produtos) {
  apiConfig.setUrlAgendaServicosApi(
    produtos.filter((x) => x.produto === "LMX.AgendaServicos.WebApi")[0].url
  );
  apiConfig.setUrlVendaFacil(
    produtos.filter((x) => x.produto === "VendaFacilWebApp")[0].url
  );
  apiConfig.setUrlErpWebApp(
    produtos.filter((x) => x.produto === "ERP.WebApp")[0].url
  );
  apiConfig.setUrlSuprimentosApi(
    produtos.filter((x) => x.produto === "LMX.Suprimentos.WebApi")[0].url
  );
  apiConfig.setUrlCrmApi(
    produtos.filter((x) => x.produto === "LMX.CRM.WebApi")[0].url
  );
};

const AgendaServicosApiService = {
  autenticacaoPorAlias: (payload) => {
    return new Promise((resolve, reject) => {
      const urlRequest =
        apiConfig.getUrlAgendaServicosApi() + "/api/autenticacao/gerarToken";

      const requestData = {
        Produtos: NOMES_PRODUTOS_API,
        urlErpAdmin: apiConfig.getUrlErpAdminApi(),
        Alias: payload.Alias,
      };

      if (idConfigAmbiente)
        requestData.IdAmbienteProdutos = idConfigAmbiente;

      apiClient
        .post(urlRequest, requestData, {})
        .then((response) => {
          const retornoApi = response.data;
          registrarUrlAPIs(retornoApi.produtosUrls);
          apiConfig.setToken(retornoApi.tokenJWT);

          ApiService.init();
          store.commit(mutations.AUTENTICACAO_MICROVIX_AGENDAMENTO_ONLINE, { autenticado: true, alias: payload.Alias });
          resolve(retornoApi);
        })
        .catch((error) => {
          apiConfig.reset();
          store.commit(mutations.LIMPAR_AUTENTICACAO_MICROVIX_AGENDAMENTO_ONLINE);
          reject(error);
        });
    });
  },
};

export default AgendaServicosApiService;
